import APIKit from './Apikit'
export const pagesContent = async (type, link) => {
  const url = `/pages${link}/${type}`
  try {
    const response = await APIKit.get(url)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
export const listContent = async (type, link) => {
  const url = `/lists${link}/${type}`
  try {
    const response = await APIKit.get(url)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const commitmentSection = async (type, link, parentID) => {
  const url = `/lists${link}/${type}/${parentID}`
  try {
    const response = await APIKit.get(url)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getDropdownData = async (link, type) => {
  const url = `/${link}/${type}`
  try {
    const response = await APIKit.get(url)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const listVideo = async (id, lng) => {
  const url = `/lists/lst_video/item/${id}/${lng}`
  try {
    const response = await APIKit.get(url)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
